const SMS_NUMBER = '359';

const getCapacitor = () => {
    if (typeof window === 'undefined') {
        return null;
    }

    return window.Capacitor || null;
};

export const isInstallerNativeApp = () => {
    const Cap = getCapacitor();

    try {
        return Boolean(Cap && Cap.isNativePlatform());
    } catch (error) {
        return false;
    }
};

export const getInstallerSmsPlugin = () => {
    if (!isInstallerNativeApp()) {
        return null;
    }

    const Cap = getCapacitor();

    if (Cap.Plugins && Cap.Plugins.InstallerSms) {
        return Cap.Plugins.InstallerSms;
    }

    if (typeof Cap.registerPlugin === 'function') {
        return Cap.registerPlugin('InstallerSms');
    }

    return null;
};

export const getSmsTargetNumber = () => SMS_NUMBER;

export const ensureSmsPermissions = async () => {
    const plugin = getInstallerSmsPlugin();

    if (!plugin) {
        throw new Error(
            'SMS доступно только в приложении монтажника'
        );
    }

    let status = await plugin.checkPermissions();

    if (status?.sms === 'granted') {
        return true;
    }

    status = await plugin.requestPermissions();

    if (status?.sms !== 'granted') {
        throw new Error(
            'Нужно разрешить доступ к SMS в настройках телефона'
        );
    }

    return true;
};

export const sendSmsTo359 = async text => {
    const plugin = getInstallerSmsPlugin();

    if (!plugin) {
        throw new Error(
            'SMS доступно только в приложении монтажника'
        );
    }

    await ensureSmsPermissions();

    return plugin.send({
        number: SMS_NUMBER,
        text: String(text || '').trim()
    });
};

export const readSmsFrom359 = async (limit = 50) => {
    const plugin = getInstallerSmsPlugin();

    if (!plugin) {
        throw new Error(
            'SMS доступно только в приложении монтажника'
        );
    }

    await ensureSmsPermissions();

    const result = await plugin.readInbox({
        number: SMS_NUMBER,
        limit
    });

    return result?.messages || [];
};
